const rupaMigration = {
  placeholder: "This is an UNAUTHENTICATED page",
  description: "Welcome to the Rupa Migration",
  button: "Start Migration",
  connect: "Connect",
  next: "Next",
  getHelp: "Get Help",
  continueToNextStep: "Continue to next step",
  supportInfo:
    "If you have any questions, please reach out to our Support team at <supportPhoneLink>{{supportPhone}}</supportPhoneLink> or <supportEmailLink>email {{supportEmail}}</supportEmailLink>",
  welcomeTitle: "Get ready to have everything in one place!",
  welcomeSubtitle: "A few things to know before you get started",
  card: {
    title: "Things to know about the move to Fullscript",
  },
  steps: {
    welcome: "Welcome",
    connectAccounts: "Connect Accounts",
    confirm: "Confirm",
    scheduleMove: "Schedule Move",
  },
  items: {
    accountInfo: {
      title: "1. Your data will move to Fullscript",
      details: {
        credentials: "Any credentials, NPI, and physician authorization status",
        orderHistory: "Order history and orders in progress",
        clientList: "Your client list ",
        favorites: "Your favorites, blood panels, and bundles",
        snippets: "Your saved text snippets",
      },
    },
    newOrders: {
      title: "2. You'll place new lab orders on Fullscript",
      details: {
        allNewOrders: "The lab companies and tests you order will be available on Fullscript",
        inProgressOrders: "All in-progress Rupa orders will now be managed in Fullscript",
        viewOnly: "Your Rupa account will be available in a view-only state",
      },
    },
    patients: {
      title: "3. Your patients will move with you",
      details: {
        redirectedToFullscript:
          "When your patients log in to Rupa, they'll be redirected to Fullscript with a brief explanation of the move",
        results: "Your patients' historical and new results will be available in Fullscript",
        communicationWithPatients:
          "We won't email your patients about this change—it's up to you if and how you choose to communicate it with them",
      },
    },
  },
  emailLabel: "Email",
  passwordLabel: "Password",
  requiredIndicator: "*",
  createAccountButton: "Create account",
  patient: {
    joinHeading: "Join {{practitionerFullName}} on Fullscript",
    joinHeadingSendActivationEmail: "Join your practitioner on Fullscript",
    joinSubheading: "Your practitioner now uses Fullscript to manage labs. Create an account to:",
    benefit1: "View all your past lab results from Rupa",
    benefit2: "Purchase and manage new lab orders",
    benefit3: "Purchase high-quality supplements",
    passwordHeading: "Set a password for your new account",
  },
  termsText: "I agree to Fullscript's <1>Terms of Service</1> and <2>Privacy policy</2>.",
  clerk: {
    joinHeading: "Get excited, {{name}}!",
    joinHeadingExisting: "Welcome to {{-dispensaryName}}!",
    joinSubheading: "On Fullscript, you will be able to:",
    benefit1: "Order all of your labs and supplements from Fullscript",
    benefit2: "Get access to more blood lab options, including Quest!",
    benefit3: "Build and re-use plans for common treatments",
    benefit4: "Much more to come!",
    passwordHeading: "Create your new Fullscript account",
    alreadyHaveAccount: "Already have an account? <1>Sign in</1>",
  },
  practitioner: {
    joinHeading: "Get excited, {{name}}!",
    joinHeadingExisting: "Welcome to {{-dispensaryName}}!",
    joinSubheading: "On Fullscript, you will be able to:",
    benefit1: "Access top lab tests & supplements in one place",
    benefit2: "Offer a modern, streamlined testing experience",
    benefit3: "Turn results into actions with AI-powered insights",
    benefit4: "Get expert support by phone, chat, or email",
    passwordHeading: "Create your new Fullscript account",
    alreadyHaveAccount: "Already have an account? <1>Sign in</1>",
  },
  onboarding: {
    signDocuments: {
      success: "Documents signed successfully",
    },
  },
  OrderOnRupa: "Ordered on Rupa Health",
} as const;

export { rupaMigration };
